import { render, staticRenderFns } from "./BatchImportAccount.vue?vue&type=template&id=fd4a2b70&scoped=true"
import script from "./BatchImportAccount.vue?vue&type=script&lang=js"
export * from "./BatchImportAccount.vue?vue&type=script&lang=js"
import style0 from "./BatchImportAccount.vue?vue&type=style&index=0&id=fd4a2b70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd4a2b70",
  null
  
)

export default component.exports